import { GetCreditMemosParameter } from "@dana/Store/Data/ViewCredit/Handlers/ViewCreditHandler";
import { CreditStateActions } from "@dana/Store/Data/ViewCredit/Reducers/ViewCreditReducer";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";


type HandlerType = ApiHandlerDiscreteParameter<
    GetCreditMemosParameter,
    null,
    null,
    DispatchProp<CreditStateActions>
>;

export const UpdateFilter: HandlerType = props => {
    props.dispatch({
        type: "CreditViewState/UpdateViewCreditFilter",
        filter: props.parameter,
    });
};


export const chain = [UpdateFilter];

const updateCreditFilterFields = createHandlerChainRunner(chain, "UpdateCreditFilterFields");
export default updateCreditFilterFields;